import React from "react";
import { connect } from "react-redux";
import Maincontent from "./Maincontent";
import { Breadcrumb } from "antd";

const EmployeeAuth = () => {
    return (
        <>
            <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>Settings</Breadcrumb.Item>
                <Breadcrumb.Item>Employee PIN Setup</Breadcrumb.Item>
            </Breadcrumb>
            <Maincontent />
        </>
    );
};

export default connect()(EmployeeAuth);
